$(document).ready(() => {
  function e(t) {
    $('.options-frame option:not(.unframed)').each(function () {
      $(this).hasClass(t)
        ? $(this)
            .removeClass('hide')
            .show()
            .prop('disabled', !1)
            .toggleOption(!0)
        : $(this)
            .addClass('hide')
            .hide()
            .prop('selected', !1)
            .removeAttr('selected')
            .prop('disabled', !0)
            .toggleOption(!1);
    });
  }
  function i(t) {
    let e = t.find('.options-size option:selected').attr('data-price'),
      o = t.find('.options-frame option:selected').attr('data-price'),
      i = t.find('.options-denominations option:selected').attr('data-price');
    (
      (e /= 100),
      (i /= 100),
      (i = (o /= 100) ? e + o : i || e),
      t
        .find('.regular-price-js')
        .text(
          (e = (e = i).toString().split('.'))[0].replace(
            /\B(?=(\d{3})+(?!\d))/g,
            ','
          ) + (e[1] ? `.${  e[1]}` : '')
        ));
  }
  (1 < history.length &&
    $('.main-product__back-btn').attr('href', 'javascript:history.go(-1)'),
    $('.main-product__select--framing').change(function () {
      ($('.product__media')
        .removeClass('product__media--black')
        .removeClass('product__media--white'),
        -1 < $(this).val().indexOf('Unframed') ||
          $('.product__media').addClass('product__media--black'));
    }),
    (jQuery.fn.toggleOption = function (t) {
      (jQuery(this).toggle(t),
        t
          ? jQuery(this).parent('span.toggleOption').length &&
            jQuery(this).unwrap()
          : 0 === jQuery(this).parent('span.toggleOption').length &&
            jQuery(this).wrap(
              '<span class="toggleOption" style="display: none;" />'
            ));
    }),
    $('.main-product').each(function () {
      i($(this));
    }),
    e($('.options-size').val()),
    $('.options-size').change(function () {
      const o = $('.options-frame option:selected').val(),
        t = (e($(this).val()), $(this).closest('.main-product'));
      (
        $(this)
          .find('.options-frame option')
          .each(function (t, e) {
            $(this).val() !== o ||
              $(this).hasClass('hide') ||
              $(this)
                .attr('selected', 'selected')
                .prop('selected', !0)
                .trigger('change');
          }),
        i(t));
    }),
    $('.options-frame').change(function () {
      i($(this).closest('.main-product'));
    }),
    $('.options-denominations').change(function () {
      i($(this).closest('.main-product'));
    }));
});
